/**
 * Report Type utility functions
 * Uses API data directly - NO hard-coded mappings!
 */

/**
 * Get report type by ID from API data
 * @param {Array} reportTypes - Report types from API
 * @param {string} id - Report type ID (UUID)
 * @returns {Object|null} Report type object or null
 */
export const getReportTypeById = (reportTypes, id) => {
  if (!Array.isArray(reportTypes) || !id) return null;
  return reportTypes.find(type => type.id === id) || null;
};

/**
 * Get report type by code from API data
 * @param {Array} reportTypes - Report types from API
 * @param {string} code - Report type code
 * @returns {Object|null} Report type object or null
 */
export const getReportTypeByCode = (reportTypes, code) => {
  if (!Array.isArray(reportTypes) || !code) return null;
  return reportTypes.find(type => type.code === code) || null;
};

/**
 * Convert report types array to options for Select component
 * @param {Array} reportTypes - Report types from API
 * @param {Function} intl - React Intl formatter
 * @returns {Array} Options array for Select
 */
export const reportTypesToOptions = (reportTypes, intl) => {
  if (!Array.isArray(reportTypes)) return [];

  return reportTypes.map(type => ({
    value: type.id,
    label: intl?.formatMessage({
      id: `ui-reports.reportTypes.name.${type.code}`,
      defaultMessage: type.name || type.code,
    }),
    code: type.code,
    ...type
  }));
};

/**
 * Get display name for report type
 * @param {Array} reportTypes - Report types from API
 * @param {string} idOrCode - Report type ID or code
 * @returns {string} Display name
 */
export const getReportTypeDisplayName = (reportTypes, idOrCode) => {
  if (!Array.isArray(reportTypes) || !idOrCode) return '';
  
  const type = reportTypes.find(t => t.id === idOrCode || t.code === idOrCode);
  return type?.name || idOrCode;
};
